module.exports = __webpack_public_path__ + "static/how-it-works-3019ad629023c9d6a47f49a841252b73.mp4";